import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronLeft24 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9.914 12 5.293-5.293-1.414-1.414L7.086 12l6.707 6.707 1.414-1.414z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconChevronLeft24);
export default ForwardRef;
